import { useParams, useNavigate } from 'react-router-dom'

export default function GuestRegistrationSuccessPage() {
  const { adminId } = useParams<{ adminId: string }>()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 sm:py-12">

      <div className="mx-auto max-w-2xl">

        {/* Header */}

        <div className="mb-8 text-center">

          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-green-100">

            <svg
              className="h-10 w-10 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>

          </div>

          <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Онлайн-регистрация завершена
          </h1>

          <p className="mt-3 text-slate-500">
            Ваши данные успешно обработаны
          </p>

        </div>


        {/* Main card */}

        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">

          <div className="p-6 sm:p-8">

            {/* Success message */}

            <div className="rounded-2xl border border-green-200 bg-green-50 p-5">

              <div className="flex items-start gap-3">

                <div className="mt-0.5 text-xl">
                  ✓
                </div>

                <div>

                  <h2 className="font-semibold text-green-900">
                    Регистрация успешно завершена
                  </h2>

                  <p className="mt-2 text-sm leading-6 text-green-700">
                    Ваши данные обработаны, а документы переданы администратору отеля для проверки.
                  </p>

                </div>

              </div>

            </div>


            {/* What happens next */}

            <div className="mt-6">

              <h3 className="text-lg font-semibold text-slate-900">
                Что произойдёт дальше?
              </h3>

              <div className="mt-5 space-y-4">


                <div className="flex items-start gap-4">

                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100 font-semibold text-green-600">
                    ✓
                  </div>

                  <div>

                    <p className="font-medium text-slate-900">
                      Данные обработаны
                    </p>

                    <p className="mt-1 text-sm leading-6 text-slate-500">
                      Информация гостя использована для автоматической подготовки документов.
                    </p>

                  </div>

                </div>


                <div className="flex items-start gap-4">

                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-100 font-semibold text-blue-600">
                    2
                  </div>

                  <div>

                    <p className="font-medium text-slate-900">
                      Администратор проверит документы
                    </p>

                    <p className="mt-1 text-sm leading-6 text-slate-500">
                      Готовый договор доступен администратору в личном кабинете отеля.
                    </p>

                  </div>

                </div>


                <div className="flex items-start gap-4">

                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 font-semibold text-slate-500">
                    3
                  </div>

                  <div>

                    <p className="font-medium text-slate-900">
                      Продолжайте заселение
                    </p>

                    <p className="mt-1 text-sm leading-6 text-slate-500">
                      Если потребуется, обратитесь к администратору на ресепшене.
                    </p>

                  </div>

                </div>

              </div>

            </div>


            {/* Privacy note */}

            <div className="mt-6 flex items-start gap-3 rounded-2xl bg-slate-50 p-4">

              <span className="text-lg">
                🔒
              </span>

              <p className="text-sm leading-6 text-slate-500">
                Фотография паспорта используется только для распознавания данных и не хранится после обработки.
              </p>

            </div>


            {/* Actions */}

            <div className="mt-8 space-y-3">

              <button
                onClick={() => navigate(`/guest/${adminId}`)}
                className="w-full rounded-2xl bg-blue-600 px-5 py-4 font-semibold text-white transition hover:bg-blue-700"
              >
                Зарегистрировать ещё одного гостя
              </button>

              <button
                onClick={() => navigate('/')}
                className="w-full rounded-2xl px-5 py-3 font-medium text-slate-500 transition hover:bg-slate-50 hover:text-slate-700"
              >
                На главную
              </button>

            </div>

          </div>

        </div>


        {/* Footer */}

        <div className="mt-5 flex items-center justify-center gap-2 text-center text-xs text-slate-400">

          <span>HotelCheck</span>

          <span>•</span>

          <span>Онлайн-регистрация гостей</span>

        </div>

      </div>

    </div>
  )
}